import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datasheet-session-editor',
  templateUrl: './datasheet-session-editor.component.html',
  styleUrls: ['./datasheet-session-editor.component.scss']
})
export class DatasheetSessionEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
